import { useNavigate, useOutletContext } from 'react-router-dom'

import ImportProjectsModal from 'modules/project_management/components/modals/ImportProjectsModal'

const ImportProjectsModalPage = () => {
  const navigate = useNavigate()
  const { hasImportProjectsEnabled } = useOutletContext<{ hasImportProjectsEnabled: boolean }>()

  if (!hasImportProjectsEnabled) return null

  const onClose = () => {
    navigate(-1)
  }

  return <ImportProjectsModal onClose={onClose} />
}

export default ImportProjectsModalPage
